import React from 'react';
import './Contact.css';
import Header from '../Components/Layout/Header';
import Footer from '../Components/Layout/Footer';
import Bookinginput from '../Components/Comman/Booking-input';
import Hands from '../Aseets/Img/hands.svg';
import FQA_cards from '../Components/Comman/FQA';

const Cards = (props) => {
  return (
    <>
    <Header/>
    <main>
      <section className='section1-contact'>
          <h1 className='contact-text1'>GET IN TOUCH</h1>
          <p className='contact-text2'>Have questions about the exhibition? We're here to help. Reach out to us through any of the channels below.</p>
        </section>
        <section className='section2_contact'>
            <div className='section2_div1_contact'>
             <h3 className='section2_div1_contacttext1'></h3>
             <div className='section2_div1_contactform'>
              <Bookinginput title="YOUR NAME*" type="text" placeholder="Enter your name" />
              <Bookinginput title="EMAIL ADDRESS*" type="email" placeholder="your.email@example.com" />
              <Bookinginput title="SUBJECT*" type="text" placeholder="What is this regarding?" />
              <Bookinginput title="MESSAGE*" type="text" placeholder="Write your message here..." />
            </div>   
            <button className='booking_button'>SEND MESSAGE</button>
            </div>
            <div className='section2_contactdiv2'>
                <h2 className='section2_div2_contacttext1'>WHY CONTACT US?</h2>
                <div className='section2_contactdiv2_2'>
                    <h6 className='section2_contactdiv2_text'>• General inquiries about the exhibition</h6>
                    <h6 className='section2_contactdiv2_text'>• Exhibitor and partnership opportunities</h6>
                    <h6 className='section2_contactdiv2_text'>• Press and media requests</h6>
                    <h6 className='section2_contactdiv2_text'>• Group bookings and corporate packages</h6>
                    <h6 className='section2_contactdiv2_text'>• Accessibility assistance</h6>
                    <h6 className='section2_contactdiv2_text'>• Event sponsorship information</h6>
                    <h6 className='section2_contactdiv2_text'>• Press and media requests</h6>
                    <h6 className='section2_contactdiv2_text'>• Group bookings and corporate packages</h6>
                    <h6 className='section2_contactdiv2_text'>• Accessibility assistance</h6>
                    <h6 className='section2_contactdiv2_text'>• Event sponsorship information</h6>
                </div>
            </div>
        </section>
        <section className='sectionfqa'>
          <div className='sectionfqa_bg'>
            <div className='sectionfqa_img_wrapper'>
           <img className='sectionfqa_svg' src={Hands} alt="Hands" />
           <div className='sectionfqa_glow'></div>
           </div>
            <div className='sectionfqa_div1'>
              <div className='sectionfqa_div2'>gi
                <h3 className='sectionfqa_text1'>Answers</h3>
                <div className='sectionfqa_div3'>
                  <div className='sectionfqa_line'></div>
                  <FQA_cards title="What is Nebu ?" text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}/>
                  <div className='section7_line'></div>
                  <FQA_cards title="What is Nebu ?" text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}/>
                  <div className='section7_line'></div>
                  <FQA_cards title="What is Nebu ?" text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}/>
                  <div className='section7_line'></div>
                  <FQA_cards title="What is Nebu ?" text={`NEBU meaning "gold" in ancient Egyptian brings together the finest jewelry makers, goldsmiths, and luxury gem traders from across Egypt and the Arab world under one roof.`}/>
                </div>
              </div>
            </div>
          </div>
        </section>
    </main>
    <Footer/>
    </>
  );
};

export default Cards;